import { useNavigate } from "react-router-dom"
import useListGroupBu from "./useListGroupBu"
import { useEffect, useState } from "react"
import { BsPencilSquare, BsFillTrashFill } from "react-icons/bs"
import DeleteModal from "../../../../components/modal/DeleteModal"
import Loading from "../../../../components/loading/Loading"
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"

const ListGroupBusinessUnit = ({ hideCreateButton = false }) => {
    const navigate = useNavigate()
    const {
        payload,
        getListGroupBu,
        deleteGroupBusinessUnit,
        loadingPagestate
    } = useListGroupBu()

    useEffect(() => {
        getListGroupBu()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    const [deleteID, setDeleteID] = useState()
    const [userName, setName] = useState()
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return(
        <div>
            <Loading state={loadingPagestate}/>
            {!hideCreateButton && (
                <div className="d-flex">
                    <ActionButtonGradient
                        onClick={() => navigate('/bu-management/gbu-form')}
                        variant="success"
                        children={"Create Group Business Unit"}
                    />
                </div>
            )}
            <div className="table-responsive">
                <table className="table align-items-center">
                    <thead>
                        <tr>
                        <th scope="col">Group Business Unit Name</th>
                        <th scope="col">Status</th>
                        <th scope="col" style={{width: '5%'}}></th>
                        <th scope="col" style={{width: '5%'}}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            payload.map((data) => (
                                <tr key={data.ID}>
                                    <td>{data.GroupName}</td>
                                    <td>{data.Status?"Active":"Not Active"}</td>
                                    <td className="text-center">
                                        <button 
                                            className="btn"
                                            title="Edit Group Business Unit"
                                            onClick={() => navigate(`/bu-management/gbu-form/${data.ID}`)}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '5px',
                                                border: '1px solid #02B4CC',
                                                backgroundColor: 'transparent',
                                                color: '#02B4CC',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#02B4CC';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#02B4CC';
                                            }}
                                        >
                                            <BsPencilSquare/>
                                            Edit
                                        </button>
                                    </td>
                                    <td className="text-center">
                                        <button 
                                            className="btn"
                                            title="Delete Group Business Unit" 
                                            onClick={() => {
                                                handleShow()        
                                                setDeleteID(data.ID)
                                                setName(data.GroupName)
                                            }}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '5px',
                                                border: '1px solid #dc3545',
                                                backgroundColor: 'transparent',
                                                color: '#dc3545',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#dc3545';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#dc3545';
                                            }}
                                        >
                                            <BsFillTrashFill/>
                                            Delete
                                        </button>
                                    </td>
                                </tr>     
                                
                            ))
                        } 
                    </tbody>
                </table>
            </div>
            <DeleteModal 
                show={show} 
                handleClose={handleClose} 
                handleOk={async () => {
                    await deleteGroupBusinessUnit(deleteID, () => getListGroupBu())
                    handleClose()
                }} 
                title={userName}
            />
        </div>
    )
}

export default ListGroupBusinessUnit